import axios from '../../../config/axiosConfig';
import { AdminsResponse, Admin } from '../../../shared';
import { ErrorResponse } from '../../../shared';

export const fetchAdmins = async(abortController: AbortController): Promise<AdminsResponse|ErrorResponse> => {
  const body = {
    adminId: -1,
    studentId: ''
  };
  const response = await axios.post<Admin[]>('api/report/admins', body, {signal: abortController.signal})
    .then(res => res.data)
    .then((admins):AdminsResponse => ({
      __typename: 'AdminsResponse',
      admins
    }))
    .catch((errMsg): ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};